import { useState, useEffect } from "react"
import axios from 'axios';
import ReactMarkdown from "react-markdown"
import 'github-markdown-css';
// import rehypeRaw from 'rehype-raw'
// import rehypeSanitize from 'rehype-sanitize'
// import LeftNav from "../components/LeftNavigation/leftNav";

import RightRail from "../components/RightNavigation/rightRail";
import { DIRECTUS_URL } from '../constants/declarations'
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter'
import { dark } from 'react-syntax-highlighter/dist/esm/styles/prism'
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw'
import rehypeGithubAlerts from 'rehype-github-alert'
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Chatbot from "../components/RightNavigation/Chatbot";
import { getCookie } from "../utils/utilFunctions";


// Extract visible text from a rendered Markdown AST node.
const getMarkdownNodeText = (node) => {
    if (!node) return '';
    if (node.type === 'text') return node.value || '';
    return Array.isArray(node.children)
        ? node.children.map(getMarkdownNodeText).join('')
        : '';
};


export default function Benchmarks() {
    const [markdownText, setMarkdownText] = useState('');
    // let jwtToken = getCookie('jwtToken');
    const [copiedIndex, setCopiedIndex] = useState(null);
    const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
    
    useEffect(() => {
        const userCookie = getCookie('jwtToken');

        if (userCookie !== '') {
            setIsUserLoggedIn(true);
        }

    }, [isUserLoggedIn]);

    const handleCopy = (index) => {
        setCopiedIndex(index);
        setTimeout(() => setCopiedIndex(null), 2000); // Reset after 2 seconds
    };

    let codeBlockIndex = -1;

    useEffect(() => {
        async function fetchFileData() {
            const localFilePath = `/markdown/benchmarks.md`;

            try {
                const localResponse = await fetch(localFilePath);

                if (localResponse.ok) {
                    const contentType =
                        localResponse.headers.get('content-type') || '';

                    const markdownData = await localResponse.text();

                    // Detect HTML returned by React's SPA fallback
                    const isHtml =
                        contentType.includes('text/html') ||
                        /^\s*(<!doctype\s+html|<html\b)/i.test(markdownData);

                    if (!isHtml) {
                        setMarkdownText(markdownData);

                        console.log(
                            'Markdown loaded from local file:',
                            localFilePath
                        );

                        return;
                    }
                }

                console.log('Local Markdown not found. Falling back to Directus API.');

            } catch (error) {
                console.warn('Unable to load local Markdown:', error);
            }
            
            try {
                const response = await axios.get(DIRECTUS_URL + "/items/filemappings?filter[filename]=benchmarks");
                const data = response.data.data;

                if (data.length === 1) {
                    const fileMappingObject = data[0];
                    const fileID = fileMappingObject.fileID;
                    if (fileID !== null) {
                        fetch(DIRECTUS_URL + "/assets/" + fileID)
                            .then(response => response.text())
                            .then(data => setMarkdownText(data))
                            .catch(error => console.error('Error retrieving markdown:', error));
                    }
                }

            } catch (error) {
                console.error('Error retrieving data:', error);
            }
        }

        fetchFileData();
    }, []);

    return (
        <div className="task-results-container eighty-twenty-grid">
            <div className="main-content task-builder-task">
                <ReactMarkdown
                    remarkPlugins={[remarkGfm]}
                    rehypePlugins={[rehypeRaw, rehypeGithubAlerts]}
                    children={markdownText}
                    components={{
                        p({ node, children, style, ...props }) {
                            // Center figure captions without changing the Markdown source.
                            // Example: *Figure 10. Download an integration-and-annotation result.*
                            const isFigureCaption = /^Figure\s+\d+[a-z]?\s*[.:]/i.test(
                                getMarkdownNodeText(node).trim()
                            );

                            return (
                                <p
                                    {...props}
                                    style={{
                                        ...style,
                                        ...(isFigureCaption ? { textAlign: 'center' } : {}),
                                    }}
                                >
                                    {children}
                                </p>
                            );
                        },
                        img({ node, alt, style, ...props }) {
                            return (
                                <img
                                    {...props}
                                    alt={alt ?? ''}
                                    style={{
                                        ...style,
                                        display: 'block',
                                        marginLeft: 'auto',
                                        marginRight: 'auto',
                                        maxWidth: '100%',
                                        height: 'auto',
                                    }}
                                />
                            );
                        },
                        code(props) {
                            const { children, inline, className, node, ...rest } = props;
                            const match = /language-(\w+)/.exec(className || '');
                            if (!inline && match) {
                                codeBlockIndex++;

                                const currentIndex = codeBlockIndex;
                                const codeText = String(children).replace(/\n$/, '');

                                return (
                                    <div style={{ position: 'relative' }}>
                                        <SyntaxHighlighter
                                            {...rest}
                                            PreTag="div"
                                            children={codeText}
                                            language={match[1]}
                                            style={dark}
                                        />
                                        <CopyToClipboard text={codeText} onCopy={() => handleCopy(currentIndex)}>
                                            <button style={{
                                                position: 'absolute',
                                                top: '5px',
                                                right: '5px',
                                                background: '#333',
                                                color: '#fff',
                                                border: 'none',
                                                borderRadius: '4px',
                                                cursor: 'pointer',
                                                padding: '5px 10px',
                                            }}>{copiedIndex === currentIndex ? 'Copied!' : 'Copy'}</button>
                                        </CopyToClipboard>
                                    </div>
                                );
                            }

                            // Fallback for inline code or unknown language
                            return (
                                <code {...rest} className={className}>
                                    {children}
                                </code>
                            );
                        }
                    }}
                />
            </div>
            <Chatbot presetQuestions={null} />
            {isUserLoggedIn && (
                <div className="right-rail">
                    <RightRail />
                </div>
            )}
        </div >
    )
}